import { isObservable, Observable, of } from "rxjs";

export function isPNR(str: string): boolean {
  const pattern = /^[a-zA-Z0-9]{6,6}$/
  return pattern.test(str);
}

export function ensureObservable(val: string | Observable<string>): Observable<string> {
  if(!isObservable(val)){
    return of(val);
  }
  return val;
}
